export default __webpack_public_path__ + "static/media/group-icon.fdeba862.svg";